import React, { useState, useEffect } from 'react';
import './DragupButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const DragupButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    // Use scrollY or pageYOffset for better browser support
    const scrollPosition = window.scrollY || window.pageYOffset;
    setIsVisible(scrollPosition > 130);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <a
      href="#"
      aria-label="Scroll to top"
      className={`drag-up ${isVisible ? 'du-fixed' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        scrollToTop();
      }}
    >
      <FontAwesomeIcon icon={faArrowUp} />
    </a>
  );
};

export default DragupButton;
